import { render, staticRenderFns } from "./CmgLoyaltyPepper.vue?vue&type=template&id=c3c5fc1e&scoped=true&lang=pug&"
import script from "./cmg-loyalty-pepper.ts?vue&type=script&lang=ts&"
export * from "./cmg-loyalty-pepper.ts?vue&type=script&lang=ts&"
import style0 from "./CmgLoyaltyPepper.vue?vue&type=style&index=0&id=c3c5fc1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c5fc1e",
  null
  
)

export default component.exports